import React, { useMemo, useState } from "react";
import InfoCadete from "./InfoCadete";
import ObtieneDatosCookies from "./obtieneDatosCookiesUsuario";
import "./ausenciasYSanciones.css";

const AusenciasYSanciones = ({ data }) => {
  const Usuario = ObtieneDatosCookies();

  const [veoAusencias, setVeoAusencias] = useState(true);
  const [veoSanciones, setVeoSanciones] = useState(true);

  const [sortConfig, setSortConfig] = useState({
    table: "sanciones",
    key: "cantidadTotalAmonestaciones",
    direction: "desc",
  });

  const handleSort = (table, key) => {
    setSortConfig((prev) => {
      if (prev.key === key && prev.table === table) {
        return {
          ...prev,
          direction:
            prev.direction === "asc" ? "desc" : "asc",
        };
      }

      return {
        table,
        key,
        direction: "asc",
      };
    });
  };

  const obtenerIconoOrden = (table, key) => {
    if (
      sortConfig.table !== table ||
      sortConfig.key !== key
    ) {
      return "↕";
    }

    return sortConfig.direction === "asc"
      ? "↑"
      : "↓";
  };

  const ausenciasFiltradas = useMemo(() => {
    let ausencias = data?.ausencias || [];

    if (
      Usuario?.sedeID == 2 &&
      String(Usuario?.destino) !== "2"
    ) {
      ausencias = ausencias.filter(
        (ausencia) =>
          ausencia.cadeteSede === "Rosario"
      );
    } else if (
      Usuario?.sedeID == 3 &&
      String(Usuario?.destino) !== "2"
    ) {
      ausencias = ausencias.filter(
        (ausencia) =>
          ausencia.cadeteSede === "Recreo"
      );
    }

    return ausencias;
  }, [
    data?.ausencias,
    Usuario?.sedeID,
    Usuario?.destino,
  ]);

  const sancionesFiltradas = useMemo(() => {
    let sanciones = data?.sanciones || [];

    if (
      Usuario?.sedeID == 2 &&
      String(Usuario?.destino) !== "2"
    ) {
      sanciones = sanciones.filter(
        (sancion) =>
          sancion.cadeteSede === "Rosario"
      );
    } else if (
      Usuario?.sedeID == 3 &&
      String(Usuario?.destino) !== "2"
    ) {
      sanciones = sanciones.filter(
        (sancion) =>
          sancion.cadeteSede === "Recreo"
      );
    }

    return sanciones;
  }, [
    data?.sanciones,
    Usuario?.sedeID,
    Usuario?.destino,
  ]);

  const sortData = (arr, tableName) => {
    if (!Array.isArray(arr)) return [];

    if (sortConfig.table !== tableName) {
      return arr;
    }

    return [...arr].sort((a, b) => {
      const valorA =
        a?.[sortConfig.key] ?? "";
      const valorB =
        b?.[sortConfig.key] ?? "";

      if (
        typeof valorA === "number" &&
        typeof valorB === "number"
      ) {
        return sortConfig.direction === "asc"
          ? valorA - valorB
          : valorB - valorA;
      }

      return sortConfig.direction === "asc"
        ? String(valorA).localeCompare(
            String(valorB),
            "es",
            {
              numeric: true,
              sensitivity: "base",
            }
          )
        : String(valorB).localeCompare(
            String(valorA),
            "es",
            {
              numeric: true,
              sensitivity: "base",
            }
          );
    });
  };

  const ausenciasOrdenadas = useMemo(
    () =>
      sortData(
        ausenciasFiltradas,
        "ausencias"
      ),
    [ausenciasFiltradas, sortConfig]
  );

  const sancionesOrdenadas = useMemo(
    () =>
      sortData(
        sancionesFiltradas,
        "sanciones"
      ),
    [sancionesFiltradas, sortConfig]
  );

  const abrirCadete = (dni) => {
    if (!dni) return;

    InfoCadete(dni);
  };

  const hayAusencias =
    ausenciasFiltradas.length > 0;

  const haySanciones =
    sancionesFiltradas.length > 0;

  if (
    !data ||
    !Array.isArray(data?.ausencias) ||
    !Array.isArray(data?.sanciones)
  ) {
    return (
      <div className="ays-empty-state">
        <div className="ays-empty-icon">
          ✓
        </div>

        <h3>Nada que mostrar todavía</h3>

        <p>
          No hay información disponible de
          inasistencias o sanciones.
        </p>
      </div>
    );
  }

  if (!hayAusencias && !haySanciones) {
    return (
      <div className="ays-empty-state">
        <div className="ays-empty-icon">
          ✓
        </div>

        <h3>Sin novedades</h3>

        <p>
          No hay tareas pendientes de ausencias o
          sanciones para la sede del usuario.
        </p>
      </div>
    );
  }

  return (
    <div className="ays-container">
      <div className="ays-summary-grid">
        <div className="ays-summary-card">
          <div className="ays-summary-icon">
            📅
          </div>

          <div>
            <span>
              Tareas por ausencias
            </span>

            <strong>
              {ausenciasFiltradas.length}
            </strong>
          </div>
        </div>

        <div className="ays-summary-card">
          <div className="ays-summary-icon">
            📋
          </div>

          <div>
            <span>
              Tareas por sanciones
            </span>

            <strong>
              {sancionesFiltradas.length}
            </strong>
          </div>
        </div>
      </div>

      {hayAusencias && (
        <section className="ays-section">
          <button
            type="button"
            className="ays-section-header"
            onClick={() =>
              setVeoAusencias(
                (estado) => !estado
              )
            }
          >
            <div className="ays-section-title">
              <span className="ays-section-icon">
                📅
              </span>

              <div>
                <h3>
                  Tareas por ausencias
                </h3>

                <p>
                  Cadetes con inasistencias
                  registradas
                </p>
              </div>
            </div>

            <div className="ays-section-actions">
              <span className="ays-section-count">
                {ausenciasFiltradas.length}
              </span>

              <span
                className={
                  veoAusencias
                    ? "ays-chevron ays-chevron-open"
                    : "ays-chevron"
                }
              >
                ⌄
              </span>
            </div>
          </button>

          {veoAusencias && (
            <div className="ays-table-wrapper">
              <table className="ays-table">
                <thead>
                  <tr>
                    <th className="ays-index-column">
                      #
                    </th>

                    <SortableHeader
                      label="Cadete"
                      table="ausencias"
                      sortKey="cadeteInfo"
                      onSort={handleSort}
                      icon={obtenerIconoOrden(
                        "ausencias",
                        "cadeteInfo"
                      )}
                    />

                    <SortableHeader
                      label="DNI"
                      table="ausencias"
                      sortKey="cadeteDni"
                      onSort={handleSort}
                      icon={obtenerIconoOrden(
                        "ausencias",
                        "cadeteDni"
                      )}
                    />

                    <SortableHeader
                      label="Sede"
                      table="ausencias"
                      sortKey="cadeteSede"
                      onSort={handleSort}
                      icon={obtenerIconoOrden(
                        "ausencias",
                        "cadeteSede"
                      )}
                    />

                    <SortableHeader
                      label="Promoción"
                      table="ausencias"
                      sortKey="promocion"
                      onSort={handleSort}
                      icon={obtenerIconoOrden(
                        "ausencias",
                        "promocion"
                      )}
                    />

                    <SortableHeader
                      label="Ausencias"
                      table="ausencias"
                      sortKey="cantidadAusencias"
                      onSort={handleSort}
                      icon={obtenerIconoOrden(
                        "ausencias",
                        "cantidadAusencias"
                      )}
                    />

                    <th>
                      Fechas registradas
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {ausenciasOrdenadas.map(
                    (ausencia, index) => {
                      const esCritica =
                        Number(
                          ausencia?.cantidadAusencias
                        ) > 15;

                      return (
                        <tr
                          key={
                            ausencia?.cadeteDni ||
                            `ausencia-${index}`
                          }
                          className={
                            esCritica
                              ? "ays-row ays-row-warning"
                              : "ays-row"
                          }
                          onClick={() =>
                            abrirCadete(
                              ausencia?.cadeteDni
                            )
                          }
                          title="Ver información del cadete"
                        >
                          <td className="ays-index-column">
                            {index + 1}
                          </td>

                          <td>
                            <div className="ays-person">
                              <div className="ays-avatar">
                                {obtenerIniciales(
                                  ausencia?.cadeteInfo
                                )}
                              </div>

                              <span>
                                {ausencia?.cadeteInfo ||
                                  "Sin nombre"}
                              </span>
                            </div>
                          </td>

                          <td>
                            <span className="ays-dni">
                              {ausencia?.cadeteDni ||
                                "-"}
                            </span>
                          </td>

                          <td>
                            <span className="ays-badge ays-badge-neutral">
                              {ausencia?.cadeteSede ||
                                "-"}
                            </span>
                          </td>

                          <td>
                            {ausencia?.promocion ||
                              "-"}
                          </td>

                          <td>
                            <span
                              className={
                                esCritica
                                  ? "ays-number-badge ays-number-danger"
                                  : "ays-number-badge"
                              }
                            >
                              {ausencia?.cantidadAusencias ??
                                0}
                            </span>
                          </td>

                          <td>
                            <div className="ays-dates">
                              {ausencia?.fechasAusencias ||
                                "Sin fechas"}
                            </div>
                          </td>
                        </tr>
                      );
                    }
                  )}
                </tbody>
              </table>
            </div>
          )}
        </section>
      )}

      {haySanciones && (
        <section className="ays-section">
          <button
            type="button"
            className="ays-section-header"
            onClick={() =>
              setVeoSanciones(
                (estado) => !estado
              )
            }
          >
            <div className="ays-section-title">
              <span className="ays-section-icon">
                📋
              </span>

              <div>
                <h3>
                  Tareas por sanciones
                </h3>

                <p>
                  Cadetes con pliegos o
                  amonestaciones
                </p>
              </div>
            </div>

            <div className="ays-section-actions">
              <span className="ays-section-count">
                {sancionesFiltradas.length}
              </span>

              <span
                className={
                  veoSanciones
                    ? "ays-chevron ays-chevron-open"
                    : "ays-chevron"
                }
              >
                ⌄
              </span>
            </div>
          </button>

          {veoSanciones && (
            <div className="ays-table-wrapper">
              <table className="ays-table">
                <thead>
                  <tr>
                    <th className="ays-index-column">
                      #
                    </th>

                    <SortableHeader
                      label="Cadete"
                      table="sanciones"
                      sortKey="cadeteInfo"
                      onSort={handleSort}
                      icon={obtenerIconoOrden(
                        "sanciones",
                        "cadeteInfo"
                      )}
                    />

                    <SortableHeader
                      label="DNI"
                      table="sanciones"
                      sortKey="cadeteDni"
                      onSort={handleSort}
                      icon={obtenerIconoOrden(
                        "sanciones",
                        "cadeteDni"
                      )}
                    />

                    <SortableHeader
                      label="Sede"
                      table="sanciones"
                      sortKey="cadeteSede"
                      onSort={handleSort}
                      icon={obtenerIconoOrden(
                        "sanciones",
                        "cadeteSede"
                      )}
                    />

                    <SortableHeader
                      label="Promoción"
                      table="sanciones"
                      sortKey="promocion"
                      onSort={handleSort}
                      icon={obtenerIconoOrden(
                        "sanciones",
                        "promocion"
                      )}
                    />

                    <SortableHeader
                      label="Pliegos"
                      table="sanciones"
                      sortKey="cantidadPliegosSanciones"
                      onSort={handleSort}
                      icon={obtenerIconoOrden(
                        "sanciones",
                        "cantidadPliegosSanciones"
                      )}
                    />

                    <SortableHeader
                      label="Amonestaciones"
                      table="sanciones"
                      sortKey="cantidadTotalAmonestaciones"
                      onSort={handleSort}
                      icon={obtenerIconoOrden(
                        "sanciones",
                        "cantidadTotalAmonestaciones"
                      )}
                    />
                  </tr>
                </thead>

                <tbody>
                  {sancionesOrdenadas.map(
                    (sancion, index) => {
                      const esCritica =
                        Number(
                          sancion?.cantidadTotalAmonestaciones
                        ) > 15;

                      return (
                        <tr
                          key={
                            sancion?.cadeteDni ||
                            `sancion-${index}`
                          }
                          className={
                            esCritica
                              ? "ays-row ays-row-danger"
                              : "ays-row"
                          }
                          onClick={() =>
                            abrirCadete(
                              sancion?.cadeteDni
                            )
                          }
                          title="Ver información del cadete"
                        >
                          <td className="ays-index-column">
                            {index + 1}
                          </td>

                          <td>
                            <div className="ays-person">
                              <div className="ays-avatar">
                                {obtenerIniciales(
                                  sancion?.cadeteInfo
                                )}
                              </div>

                              <span>
                                {sancion?.cadeteInfo ||
                                  "Sin nombre"}
                              </span>
                            </div>
                          </td>

                          <td>
                            <span className="ays-dni">
                              {sancion?.cadeteDni ||
                                "-"}
                            </span>
                          </td>

                          <td>
                            <span className="ays-badge ays-badge-neutral">
                              {sancion?.cadeteSede ||
                                "-"}
                            </span>
                          </td>

                          <td>
                            {sancion?.promocion ||
                              "-"}
                          </td>

                          <td>
                            <span className="ays-number-badge">
                              {sancion?.cantidadPliegosSanciones ??
                                0}
                            </span>
                          </td>

                          <td>
                            <span
                              className={
                                esCritica
                                  ? "ays-number-badge ays-number-danger"
                                  : "ays-number-badge"
                              }
                            >
                              {sancion?.cantidadTotalAmonestaciones ??
                                0}
                            </span>
                          </td>
                        </tr>
                      );
                    }
                  )}
                </tbody>
              </table>
            </div>
          )}
        </section>
      )}
    </div>
  );
};

const SortableHeader = ({
  label,
  table,
  sortKey,
  onSort,
  icon,
}) => {
  return (
    <th>
      <button
        type="button"
        className="ays-sort-button"
        onClick={() =>
          onSort(table, sortKey)
        }
      >
        <span>{label}</span>

        <span className="ays-sort-icon">
          {icon}
        </span>
      </button>
    </th>
  );
};

const obtenerIniciales = (nombre) => {
  if (!nombre) return "?";

  const palabras = String(nombre)
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  if (!palabras.length) return "?";

  if (palabras.length === 1) {
    return palabras[0]
      .substring(0, 2)
      .toUpperCase();
  }

  return `${palabras[0][0]}${
    palabras[palabras.length - 1][0]
  }`.toUpperCase();
};

export default AusenciasYSanciones;